<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h1>Cadastro de examinadores UNICAMP</h1>
    <button
      mat-stroked-button
      *ngIf="concursoFixo"
      (click)="navegarListaExaminadores()">
      <mat-icon>groups</mat-icon> Ver Examinadores
    </button>
  </div>
  <mat-card class="card-warning">
    Condições para cadastrar uma pessoa como examinador UNICAMP:
    <br />
    <ol type="I">
      <li>Conta de usuário estar ativa</li>
      <li>Conta de usuário não for uma conta de serviço</li>
      <li>Conta de usuário com vínculo Docente</li>
      <li>Titulação mínima de Doutor</li>
    </ol>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <fieldset fxFlex="100%">
        <legend>Busca de pessoa</legend>
        <form [formGroup]="formBuscaPessoa" fxLayout="column" fxLayoutGap="5px">
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline" fxFlex.gt-md="50%">
              <mat-label>Tipo de busca</mat-label>
              <mat-select formControlName="tipoDeBusca" name="tipoDeBusca">
                <mat-option disabled value="matricula">Matrícula</mat-option>
                <mat-option value="username">Usuário UNICAMP</mat-option>
              </mat-select>
              <mat-hint>Escolha o modo que deseja buscar uma pessoa.</mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="tipoDeBusca" appearance="outline">
              <button
                *ngIf="formBuscaPessoa.get('valor')?.value"
                matPrefix
                mat-icon-button
                aria-label="Limpar campo"
                (click)="resetSearch()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-label>{{ tipoDeBusca === 'matricula' ? 'Matrícula' : 'Usuário UNICAMP' }}</mat-label>
              <input
                matInput
                formControlName="valor"
                name="valor"
                maxlength="255"
                minlength="2"
                (keydown.enter)="$event.preventDefault(); buscarPessoa()" />
              <!-- Vue would be better in this line above -->
              <span matSuffix class="mat-suffix-custom">&commat;unicamp.br</span>
              <mat-hint>{{
                tipoDeBusca === 'matricula' ? 'Informe a Matrícula' : 'Informe o Usuário Unicamp'
              }}</mat-hint>
            </mat-form-field>
          </div>
        </form>
      </fieldset>
    </mat-card-content>
    <mat-card-actions>
      <div
        fxLayoutAlign.gt-md="end center"
        fxLayoutAlign.lt-md="center stretch"
        fxLayout.lt-md="column"
        fxLayoutGap="20px">
        <button mat-stroked-button *ngIf="concursoFixo" (click)="navegarListaExaminadores()">
          <mat-icon>groups</mat-icon> Ver Examinadores
        </button>
        <button mat-raised-button color="primary" [disabled]="formBuscaPessoa.invalid" (click)="buscarPessoa()">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </div>
    </mat-card-actions>
  </mat-card>

  <mat-card *ngIf="usuarioEncontrado.nomeCompleto">
    <mat-card-content>
      <fieldset fxFlex="100%">
        <legend>Dados da pessoa encontrada</legend>
        <!-- Exibindo os dados nos campos de mat-form-field -->
        <div fxLayout="column" fxLayoutGap="5px">
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput [value]="usuarioEncontrado.nomeCompleto" readonly [disabled]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput [value]="usuarioEncontrado.email" readonly [disabled]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Matricula</mat-label>
              <input matInput [value]="usuarioEncontrado.matricula" readonly [disabled]="true" />
            </mat-form-field>
          </div>
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Unidade</mat-label>
              <input matInput [value]="usuarioEncontrado.unidade" readonly [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Titulação</mat-label>
              <input
                matInput
                [value]="titulacaoEnum[usuarioEncontrado.titulacao || 0] || 'Sem informações'"
                readonly
                [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Situação</mat-label>
              <input
                matInput
                [value]="situacaoEnum[usuarioEncontrado.situacao || 0] || 'Sem informações'"
                readonly
                [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Data da Titulação</mat-label>
              <input
                matInput
                [value]="
                  usuarioEncontrado.dataTitulacao
                    ? (usuarioEncontrado.dataTitulacao | date : 'dd/MM/yyyy')
                    : 'Sem Informações'
                "
                readonly
                [disabled]="true" />
            </mat-form-field>
          </div>
        </div>
      </fieldset>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="usuarioEncontrado.concursosProvasData?.length">
    <table-provas-ativas-examinador [concursosProvasData]="usuarioEncontrado.concursosProvasData" />
  </mat-card>

  <mat-card class="card-warning card-warning-vinculo" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px" *ngIf="usuarioStaff">
    <mat-icon>warning</mat-icon>
    <span>Atenção: Usuário não possui vínculo docente. O cadastro na banca é permitido, mas certifique-se de que possui a titulação mínima exigida.</span>
  </mat-card>
  <mat-card *ngIf="usuarioEncontrado.nomeCompleto">
    <mat-card-content>
      <fieldset fxFlex="100%">
        <legend>Cadastrar {{ usuarioEncontrado.nomeCompleto }} como examinador</legend>
        <form [formGroup]="formCadastroExaminador" fxLayout="column" fxLayoutGap="5px" *ngIf="usuarioValido">
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline" fxFlex.gt-md="50%">
              <mat-label>Papel</mat-label>
              <mat-select formControlName="papel" name="papel">
                <mat-option value="TITULAR">Examinador titular</mat-option>
                <mat-option value="SUPLENTE">Examinador suplente</mat-option>
              </mat-select>
              <mat-hint>Papel que a pessoa irá exercer no concurso.</mat-hint>
            </mat-form-field>
            <inscricoes-autocomplete-key-value
              [options]="concursosAtivos"
              keyProperty="id"
              valueProperty="titulo"
              label="Concurso"
              placeholder="Digite para buscar..."
              hint="Concurso em que a pessoa será examinador."
              formControlName="concursoId"
              appearance="outline"
              fxFlex>
            </inscricoes-autocomplete-key-value>
          </div>
        </form>
        <mat-card class="card-danger" *ngIf="!usuarioValido">
          {{ errorMessage }}
        </mat-card>
      </fieldset>
    </mat-card-content>
    <mat-card-actions *ngIf="usuarioValido">
      <div
        fxLayoutAlign.gt-md="end center"
        fxLayoutAlign.lt-md="center stretch"
        fxLayout.lt-md="column"
        fxLayoutGap="20px">
        <button
          mat-stroked-button
          *ngIf="concursoFixo"
          (click)="navegarListaExaminadores()">
          <mat-icon>groups</mat-icon> Ver Examinadores
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="formCadastroExaminador.invalid"
          (click)="cadastrarExaminador()">
          <mat-icon>add</mat-icon> Cadastrar
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
